import { useOutletContext } from 'react-router-dom'

import { GroupsDataCollection } from 'modules/expenses/components/groups/DataCollection'
import { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'

const GroupsListTab = () => {
  const { employeeIds } = useOutletContext<TabRouteContextParams>()

  return <GroupsDataCollection employeeIds={employeeIds} />
}

export default GroupsListTab
